module.exports = __webpack_public_path__ + "img/download-app-store.a51c6ca5.jpeg";